<template>
  <div id="mapBox">
    <center-vedio v-show="showVedio" ref="centerVedio" @showMapBar="MapInfo"/>
    <div id="tmapContainer" v-show="showMap" class="map"></div>
  </div>
</template>
<script>
  import centerVedio from "./centerVedio";

  import {
    getAttributesServer,
    getAttributesShared,
    getConnectTime,
    getCredentials,
    getDeviceKey, getDeviceName,
    getDeviceValue
  } from "../untils/api/home";
  import moment from "moment";

  export default {
    name: "CenterMap",
    components: {
      centerVedio
    },
    data () {
      return {
        BMap: '',
        map: '',
        markList:[],
        markers:[],
        show: false,
        option1: {lat: '', lng: '', url:'', showFlag: false, device:{}}, //服务端经纬度数据
        latFlg1: false, //服务端纬度标识符
        lngFlg1: false ,//服务端经度标识符
        option2: {lat: '', lng: '', url:'', showFlag: false, device:{}}, //共享端经纬度数据
        latFlg2: false, //共享端纬度标识符
        lngFlg2: false, //共享端经度标识符
        option3: {lat: '', lng: '', url:'', showFlag: false, device:{}}, //最新遥测经纬度数据
        latFlg3: false, //最新遥测数据纬度标识符
        lngFlg3: false, // 最新遥测数据经度标识符
        name:'',
        valueList: [],
        lat: 0,
        lng: 0,
        time:'',
        shareList: [],
        showMap: true,
        showVedio: false,
        defaultDeviceId: '',
        currentInfoWindow: null
      }
    },

    beforeDestroy() {
      clearInterval(this.time);
    },

    mounted() {
      this.loadTianditu();
    },

    methods: {
      loadTianditu() {
        if (typeof T !== 'undefined') {
          this.initMap();
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=b605394410079145db1525d2c8fa27aa';
        script.onload = () => {
          setTimeout(() => this.initMap(), 50);
        };
        document.body.appendChild(script);
      },

      initMap() {
        try {
          const center = new T.LngLat(103.817535, 36.132308);
          this.map = new T.Map('tmapContainer');
          this.map.centerAndZoom(center, 4);
          this.map.enableScrollWheelZoom();
          this.addCustomControls();

          const mapTypeControl = new T.Control.MapType({
            mapTypes: [
              TMAP_NORMAL_MAP,    // 普通地图
              TMAP_SATELLITE_MAP  // 卫星地图
            ],
            position: T_ANCHOR_TOP_RIGHT,
            offset: new T.Point(10, 10) // 偏移量
          });
          this.map.addControl(mapTypeControl);

          document.getElementsByClassName("tdt-control-copyright tdt-control")[0].style.display = 'none'
        } catch (e) {
          console.error('initMap error', e);
        }

        this.map.addEventListener('click', () => {
          if (this.currentInfoWindow) {
            this.map.closeInfoWindow(this.currentInfoWindow);
            this.currentInfoWindow = null;
          }
        });
      },

      addCustomControls() {
        const that = this;

        // ===========================
        // 自定义组合控件（包含：视频按钮 + 全屏按钮）
        // ===========================
        const CombinedControl = T.Control.extend({
          options: {
            position: T_ANCHOR_TOP_LEFT,
            offset: new T.Point(10, 10)
          },

          onAdd: function (map) {
            // --- 外部容器 ---
            const container = document.createElement("div");
            container.style.display = "flex";
            container.style.width = "80px";        // 两个按钮间距
            container.style.justifyContent = "space-between";
            container.style.alignItems = "center";
            container.style.zIndex = "9999";

            // ================
            // 2. 全屏按钮
            // ================
            const fullBtn = document.createElement("img");
            fullBtn.src = require('./img/enlarge3.png');
            fullBtn.style.width = "32px";
            fullBtn.style.height = "32px";
            fullBtn.style.cursor = "pointer";

            let isFull = false;

            fullBtn.onclick = function () {
              const element = document.getElementById("mapBox");

              if (!isFull) {
                isFull = true;
                fullBtn.src = require('./img/narrow3.png');

                if (element.requestFullscreen) element.requestFullscreen();
                else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
                else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
                else if (element.msRequestFullscreen) element.msRequestFullscreen();

              } else {
                isFull = false;
                fullBtn.src = require('./img/enlarge3.png');

                if (document.exitFullscreen) document.exitFullscreen();
                else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
                else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
                else if (document.msExitFullscreen) document.msExitFullscreen();
              }
            };

            container.appendChild(fullBtn);

            // ================
            // 1. 视频按钮
            // ================
            const videoBtn = document.createElement("img");
            videoBtn.src = require('./img/vedio1.png');
            videoBtn.style.width = "36px";
            videoBtn.style.height = "36px";
            videoBtn.style.cursor = "pointer";

            videoBtn.onclick = function () {
              that.showMap = false;
              that.showVedio = true;
            };

            container.appendChild(videoBtn);

            map.getContainer().appendChild(container);
            return container;
          }
        });

        this.map.addControl(new CombinedControl());
      },

      MapInfo(data) {
        this.showVedio = false;
        this.showMap = true;
      },

      /**
       * 接收home页面传递某个设备的最新遥测数据获取经纬度
       * @param deviceResponse
       */
      getDeviceDataInfos(deviceId,deviceResponse) {
        //将最新遥测的经纬度添加到集合
        this.setResponsePoint(deviceId,deviceResponse);
        if(this.defaultDeviceId !== deviceId.id){
          this.$refs.centerVedio.getSelectDevice(deviceId);
          this.defaultDeviceId = deviceId.id;
        }
      },

      /**
       * 接收home页面传递的设备集合获取经纬度
       * @param deviceBoards
       */
      getDeviceInfos(deviceBoards) {
        this.markList = [];
        this.markers = [];
        //将服务端的经纬度添加到集合
        this.setServerOption(deviceBoards);
        //将共享端的经纬度添加到集合
        this.setSharedPoint(deviceBoards);
        //每隔三小时访问一次
        this.time = window.setInterval(() => {
          setTimeout(() => {
            this.markList = [];
            this.markers = [];
            //将服务端的经纬度添加到集合
            this.setServerOption(deviceBoards);
            //将共享端的经纬度添加到集合
            this.setSharedPoint(deviceBoards);
          }, 0)
        },1000 * 60 *60 * 3);
        console.log("markList", this.markList);
      },

      /**
       * 将服务端的经纬度添加到集合
       * @param deviceBoards
       */
      setServerOption(deviceBoards){
        let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
        let offLine = 0;
        let allPromises = [];  // 用来记录异步是否都完成
        deviceBoards.forEach(device => {
          let option = {
            lat: '',
            lng: '',
            url: '',
            showFlag: false,
            device: device
          };
          const p = getAttributesServer(device.type, device.id).then(response => {
            let lat = null, lng = null;
            let isOnline = true;
            let lastTime = null;

            response.forEach(attr => {
              if (attr.key === 'latitude') lat = attr.value;
              if (attr.key === 'longitude') lng = attr.value;

              if (attr.key === 'lastConnectTime') {
                lastTime = attr.value;
              }

              if (attr.key === 'lastActivityTime' && lastTime === null) {
                lastTime = Number(attr.value);
              }

            });
            if (lastTime != null) {
              isOnline = !(lastTime <= beforeTime);
              // 离线计数
              if (!isOnline) offLine++;
              option.url = isOnline
                ? require("./img/bg8.png")    // 在线
                : require("./img/bg7.png");   // 离线
            }
            if (lat !== null && lng !== null) {
              option.lat = lat;
              option.lng = lng;

              let existItem = this.markList.find(m => m.device.id === device.id);

              if (existItem) {
                // 更新
                let index = this.markList.indexOf(existItem);
                this.markList[index] = option;
                this.updateMarker(option);
              } else {
                // 新增
                this.markList.push(option);
                this.addSingleMarker(option);
              }

            }
          }).catch(err => console.log("error", err));
          allPromises.push(p);
        })

        Promise.all(allPromises).then(() => {
          // 返回离线数量
          //this.$emit("callBackInfo", offLine);

          // 最后统一调整地图视野（避免每个 marker 都触发一次）
          this.setMapViewport();
        });
      },

      setSharedPoint(deviceBoards) {
        const beforeTime = new Date(moment().subtract(1, "hours")).getTime();

        // 等待 getTime() 拿到 shareList 里的 lastActivityTime
        this.getTime(deviceBoards).then(() => {

          let allPromises = [];

          deviceBoards.forEach(device => {

            // 使用本地独立对象，避免引用污染
            let option = {
              lat: '',
              lng: '',
              url: '',
              showFlag: false,
              device: device
            };

            const p = getAttributesShared(device.type, device.id)
              .then(response => {

                let lat = null, lng = null;
                let isOnline = true;

                // 找出该设备是否离线（来自 shareList）
                const sharedInfo = this.shareList.find(s => s.id === device.id);
                if (sharedInfo) {
                  isOnline = !(sharedInfo.value < beforeTime);
                }

                // 提取经纬度
                response.forEach(attr => {
                  if (attr.key === 'latitude') lat = attr.value;
                  if (attr.key === 'longitude') lng = attr.value;
                });

                // 设置 icon
                option.url = isOnline
                  ? require("./img/bg8.png")    // 在线
                  : require("./img/bg7.png");   // 离线

                // 经纬度必须都存在
                if (lat !== null && lng !== null) {
                  option.lat = lat;
                  option.lng = lng;

                  let existItem = this.markList.find(m => m.device.id === device.id);

                  if (existItem) {
                    let idx = this.markList.indexOf(existItem);
                    this.markList[idx] = option;
                    this.updateMarker(option);
                  } else {
                    this.markList.push(option);
                    this.addSingleMarker(option);
                  }
                }
              })
              .catch(err => console.log("error", err));

            allPromises.push(p);
          });

          // 所有点位更新完后统一调整视野
          Promise.all(allPromises).then(() => {
            this.setMapViewport();
          });

        });
      },

      /**
       * 获取每一个设备最后一次连接时间
       * @param deviceBoards
       */
      getTime(deviceBoards){
        this.shareList = [];
        return Promise.all(
          deviceBoards.map(device => getConnectTime(device.type, device.id).then(response => {
                this.shareList.push({
                  id: device.id,
                  value: response[0].value
                });
              })
              .catch(error => {
                console.log("error", error);
              })
          )
        );
      },

      setResponsePoint(deviceId,deviceResponse){
        let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
        // let beforeTime =   new Date(moment().subtract(3, "days")).getTime();
        let time = 0;
        Promise.all([
          getConnectTime(deviceId.entityType, deviceId.id).then(response => {
            time = response[0].value;
          }).catch(error => {
            console.log("error", error)
          })
        ]).then(() => {
          for(let obj in deviceResponse){
            //当前对象为纬度 赋值
            if(obj === 'latitude'){
              this.option3.lat = parseFloat(deviceResponse[obj][0].value);
              this.lat = parseFloat(deviceResponse[obj][0].value);
              // this.option3.url = require("./img/bg3.png");
              if(time < beforeTime){
                // this.option3.url = require("./img/bg6.png");
                this.option3.url = require("./img/bg7.png");
              } else {
                // this.option3.url = require("./img/bg3.png");
                this.option3.url = require("./img/bg8.png");
              }
              this.option3.device = deviceId;
              this.latFlg3 = true;
            }else if(obj === 'longitude' && this.lng !== parseFloat(deviceResponse[obj][0].value)){
              //当前对象为纬度赋值
              this.option3.lng =  parseFloat(deviceResponse[obj][0].value);
              this.lng = parseFloat(deviceResponse[obj][0].value);
              this.lngFlg3 = true;
            }
            //经度纬度数据赋值给集合并将标识符以及变量清空
            if(this.lngFlg3 && this.latFlg3){
              let existItem = this.markList.find(item => item.device.id === this.option3.device.id);
              if (existItem) {
                let index = this.markList.indexOf(existItem);
                this.markList[index] = this.option3;
                this.updateMarker(this.option3);
              } else {
                this.markList.push(this.option3);
                this.addSingleMarker(this.option3);
              }
              this.setMapViewport();
              this.option3 = {lat: '', lng: '', url:'', showFlag: false, device:{}};
              this.latFlg3 = false;
              this.lngFlg3 = false;
            }
          }
        })
      },

      addSingleMarker(item) {
        //console.log("2222222")
        const point = new T.LngLat(item.lng, item.lat);
        const icon = new T.Icon({
          iconUrl: item.url,
          iconSize: new T.Point(22, 33),
          iconAnchor: new T.Point(11, 33)
        });
        const marker = new T.Marker(point, { icon });
        marker.device = item.device;

        marker.addEventListener('click', async () => {
          try {
            // 直接用 this
            await this.getCenDevice(item.device);
            let name = await this.getDeviceNameFull(item.device.id);
            const rows = this.valueList.map(v => `<tr><td>${v.name}：</td><td>${v.value}</td></tr>`).join('');
            const html = `
        <div>
          <div style="font-size:16px;font-weight:bold;margin-bottom:10px;color:#FA861E;">
            ${name}
          </div>
          <table>${rows}</table>
        </div>
      `;

            const infoWindow = new T.InfoWindow(html, { offset: new T.Point(0, -30) });
            this.map.openInfoWindow(infoWindow, point);
            this.currentInfoWindow = infoWindow;

          } catch (err) {
            console.error("getCenDevice error:", err);
          }
        });

        this.map.addOverLay(marker);
        this.markers.push(marker);
      },

      updateMarker(option) {
        const marker = this.markers.find(m => m.device.id === option.device.id);
        if (marker) {
          //console.log("111111")
          const point = new T.LngLat(option.lng, option.lat);
          marker.setLngLat(point);
          marker.setIcon(new T.Icon({
            iconUrl: option.url,
            iconSize: new T.Point(22, 33),
            iconAnchor: new T.Point(11, 33)
          }));
        }
      },

      setMapViewport() {
        if (!this.map || this.markList.length === 0) return;

        const points = this.markList
          .map(m => ({
            lng: Number(m.lng),
            lat: Number(m.lat)
          }))
          .filter(p => !isNaN(p.lng) && !isNaN(p.lat))
          .map(p => new T.LngLat(p.lng, p.lat));

        if (points.length === 0) return;

        const view = this.map.getViewport(points);

        console.log("viewport:", view);

        this.map.centerAndZoom(view.center, view.zoom);
      },

      async getDeviceNameFull(deviceId) {
        try {
          const response = await getDeviceName(deviceId);
          return response.name;   // ⭐ 必须 return
        } catch (error) {
          console.log("error", error);
          return "";              // 避免报错
        }
      },

      async getCenDevice(deviceInfo) {
        try {
          const response = await getCredentials(deviceInfo.id);
          let deviceId = response.deviceId;
          return await this.getCenDeviceKey(deviceId);
        } catch (err) {
          console.log("error", err);
          throw err;
        }
      },

      async getCenDeviceKey(deviceId) {
        try {
          const response = await getDeviceKey(deviceId.entityType, deviceId.id);

          let deviceKey = '';
          let pattern = /^[A-Za-z0-9.]+$/;

          if (response.length === 0) deviceKey = 'false';

          for (let i = 0; i < response.length; i++) {
            if (pattern.test(response[i])) {
              deviceKey += (i === response.length - 1 ? response[i] : response[i] + ',');
            }
          }

          return await this.getCenNewDevice(deviceId, deviceKey); // ✅ 等待 valueList 完成
        } catch (err) {
          console.log("error", err);
          throw err;
        }
      },

      async getCenNewDevice(deviceId, deviceKey) {
        let deviceIdArray = [
          '6cccb080-6b34-11ef-be5a-c3f034c6f7c8', '6f5a94c0-6f0d-11ef-bc47-d7ca6124c18c', '460c79b0-6f0f-11ef-bc47-d7ca6124c18c', '22e72390-6f1e-11ef-bc47-d7ca6124c18c',
          'cf050a80-6f22-11ef-bc47-d7ca6124c18c', '37e40a20-6f3b-11ef-bc47-d7ca6124c18c', '5f816090-6f3c-11ef-bc47-d7ca6124c18c', '91731250-6f4c-11ef-bc47-d7ca6124c18c',
          'f398ed80-6f4f-11ef-bc47-d7ca6124c18c', '481d6660-7022-11ef-86be-f95d7c5e0879', '71787260-7023-11ef-86be-f95d7c5e0879', '2fd0d860-70f1-11ef-b67f-bfb38aaf3828',
          '4c7b42f0-717a-11ef-b67f-bfb38aaf3828', '70b11450-718f-11ef-b67f-bfb38aaf3828', 'e6751a22-7193-11ef-b67f-bfb38aaf3828', 'bf0c5550-719f-11ef-b67f-bfb38aaf3828',
          '27f06dc0-71a7-11ef-b67f-bfb38aaf3828', '00258130-71b2-11ef-b67f-bfb38aaf3828', '47a563c0-7231-11ef-b67f-bfb38aaf3828', 'af098100-723a-11ef-8ff4-7d3b1806288b',
          'ce970100-7244-11ef-8ff4-7d3b1806288b', '9cecea50-725a-11ef-8ff4-7d3b1806288b', '3fe425e1-7263-11ef-8ff4-7d3b1806288b', 'bcbdfed0-726b-11ef-8ff4-7d3b1806288b',
          '60821cc0-7273-11ef-8ff4-7d3b1806288b', 'e897f2e1-727f-11ef-8ff4-7d3b1806288b', '5d57cb80-72fa-11ef-95df-0b4de8795e45', '3e81c060-730b-11ef-95df-0b4de8795e45',
          'e576c005-731f-11ef-95df-0b4de8795e45', 'ddf0ec00-7326-11ef-95df-0b4de8795e45', '161573a0-732a-11ef-95df-0b4de8795e45', 'a80957e0-732a-11ef-95df-0b4de8795e45',
          '9c845181-732b-11ef-95df-0b4de8795e45', '5339d8f0-732c-11ef-95df-0b4de8795e45', '0fa5c760-732d-11ef-95df-0b4de8795e45'];

        this.valueList = [];
        try {
          const response = await getDeviceValue(deviceId.entityType, deviceId.id, deviceKey);

          let i = 0;
          for (let obj in response) {
            if (i === 5) break;

            let arrList = {};
            arrList.name = this.$t(obj).split(',')[0];

            if (deviceIdArray.includes(deviceId.id)) {
              if (obj == 'Amnitro') {
                arrList.value = this.calculateWater(0, 8, parseFloat(response[obj][0].value)).toFixed(2)
                  + (this.$t(obj).split(',')[1] || "");
              } else if (obj == 'dissolvedoxygen') {
                arrList.value = this.calculateWater(2, 10, parseFloat(response[obj][0].value)).toFixed(2)
                  + (this.$t(obj).split(',')[1] || "");
              } else if (obj == 'Opacity') {
                arrList.value = this.calculateWater(251, 1000, parseFloat(response[obj][0].value)).toFixed(0)
                  + (this.$t(obj).split(',')[1] || "");
              } else if (obj == 'oRp') {
                arrList.value = this.calculateWater(50, 500, parseFloat(response[obj][0].value)).toFixed(0)
                  + (this.$t(obj).split(',')[1] || "");
              }
            } else {
              arrList.value = parseFloat(response[obj][0].value).toFixed(2) + (this.$t(obj).split(',')[1] || "");
            }

            this.valueList.push(arrList);
            i++;
          }

          return this.valueList; // ✅ 返回填充完成的 valueList

        } catch (err) {
          console.log("error", err);
          throw err;
        }

      },

      calculateWater(min, max, value) {
        value = Math.abs(value);
        if(value == 0) value += 1;
        if (value >= min && value <= max) {
          return value; // 直接返回原值
        }

        if (value < min) {
          let multiplier = 2;
          while (value < min) {
            value *= multiplier;
            if (value >= min) break;
            multiplier = Math.min(multiplier + 1, max / min); // 限制 multiplier 递增幅度
          }
        } else if (value > max) {
          let divisor = 2;
          while (value > max) {
            value /= divisor;
            if (value <= max) break;
            divisor = Math.min(divisor + 1, max / min); // 限制 divisor 递增幅度
          }
        }

        return Math.min(Math.max(value, min), max); // 确保最终值在区间内
      },

    }

  };
</script>
<style lang="less" scoped>
  @import "less/centerMap.less";
</style>



// WEBPACK FOOTER //
// src/components/CenterMap.vue